module.exports = __webpack_public_path__ + "static/media/Yizel Vizcarra.88bf6437.png";